import { render, staticRenderFns } from "./fastEntry.vue?vue&type=template&id=115d9b68&scoped=true&"
import script from "./fastEntry.vue?vue&type=script&lang=js&"
export * from "./fastEntry.vue?vue&type=script&lang=js&"
import style0 from "./fastEntry.vue?vue&type=style&index=0&id=115d9b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d9b68",
  null
  
)

export default component.exports